import React, { useState } from "react";
import {
  FaGraduationCap,
  FaCalendarAlt,
  FaStar,
  FaBookOpen,
} from "react-icons/fa";
import { educationData } from "../data/portfolioData";

const EducationDesign1 = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  return (
    <section
  id="education"
  className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-gradient-to-br from-gray-50 via-white to-gray-100 dark:from-gray-900 dark:via-gray-950 dark:to-gray-900"
>
  {/* Background Grid */}
  <div className="absolute inset-0 bg-grid-pattern opacity-5 pointer-events-none" />

  {/* Content */}
  <div className="relative z-10 w-full max-w-7xl mx-auto px-4 py-20 sm:px-6 lg:px-8">
    <div className="text-center mb-12">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2">
        Education <span className="gradient-text">Journey</span>
      </h2>
      <p className="text-slate-600 dark:text-slate-400 max-w-2xl mx-auto">
        My educational background and qualifications
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {educationData.map((edu, index) => (
            <div key={index} className="group transform transition-all duration-300 hover:-translate-y-2">
              <div className="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 shadow-lg hover:shadow-xl transition-all duration-300 h-full">
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center text-white text-xl shadow-md">
                      <FaGraduationCap />
                    </div>
                    {edu.gpa === "Top ?% of Cohort" && (
                      <div className="px-2 py-1 rounded-full bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-400 text-sm font-semibold">Top Performer</div>
                    )}
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-1">{edu.degree}</h3>
                  <p className="text-emerald-600 dark:text-emerald-400 text-sm mb-3">{edu.institution}</p>
                  <div className="flex flex-wrap items-center gap-3 text-sm text-slate-600 dark:text-slate-400 mb-4">
                    <span className="flex items-center gap-1"><FaCalendarAlt size={12} /> {edu.period}</span>
                    {edu.gpa && edu.gpa !== "Details pending" && edu.gpa !== "?.?/?.?" && (
                      <span className="flex items-center gap-1"><FaStar size={12} /> {edu.gpa}</span>
                    )}
                  </div>
                  <p className="text-slate-600 dark:text-slate-400 text-sm mb-4">{edu.description}</p>
                  {edu.courses && edu.courses[0] !== "More info on its way." && (
                    <div>
                      <button
                        onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
                        className="text-emerald-600 dark:text-emerald-400 text-sm font-semibold hover:underline flex items-center gap-1 transition-all"
                      >
                        <FaBookOpen size={12} />
                        {expandedIndex === index ? "Show less" : `+ ${edu.courses.length} courses`}
                      </button>
                      {expandedIndex === index && (
                        <div className="mt-3 pt-3 border-t border-slate-200 dark:border-slate-700">
                          <div className="space-y-1.5">
                            {edu.courses.map((course, idx) => (
                              <div key={idx} className="flex items-start gap-2 text-sm text-slate-600 dark:text-slate-400">
                                <div className="w-1 h-1 rounded-full bg-emerald-500 mt-1.5" />
                                <span>{course}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
        <style jsx>{`
    .bg-grid-pattern {
      background-image:
        linear-gradient(to right, #cbd5e1 1px, transparent 1px),
        linear-gradient(to bottom, #cbd5e1 1px, transparent 1px);
      background-size: 40px 40px;
    }

    .dark .bg-grid-pattern {
      background-image:
        linear-gradient(to right, #334155 1px, transparent 1px),
        linear-gradient(to bottom, #334155 1px, transparent 1px);
    }
  `}</style>
    </section>
  );
};

export default EducationDesign1;